export function formatRating(value: number | null): string {
  return value === null ? "—" : `${value.toFixed(1)}/5`;
}

export function formatHours(value: number | null): string {
  return value === null ? "—" : `${value.toFixed(1)}h`;
}
